<div class="page-shell">
  <header class="topbar">
    <div class="topbar-left">
      <app-horizontal-menu
        class="top-nav"
        [items]="topMenuItems"
        [selectedIndex]="selectedTopMenuIndex"
        (itemSelected)="selectTopMenu($event)"
      ></app-horizontal-menu>
      <button class="btn-outline" type="button" (click)="logout()">Se déconnecter</button>
    </div>
    
  </header>

  <main class="content-layout" [class.home-layout]="isHomeRoute">
    @if (!isHomeRoute) {
      <app-vertical-menu
        [title]="currentLeftTitle"
        [groups]="articleMenuGroups"
        [activePath]="currentUrl"
      ></app-vertical-menu>
    }

    <section class="content-panel">
      <router-outlet></router-outlet>
    </section>
  </main>

  <footer class="page-footer">BiodivScan Intranet</footer>
</div>
